import { IOrder } from '@quizzach/interfaces';
import { fetchData, consoleDev, ConsoleStatus } from '@quizzach/utils';
import { useState } from 'react';
import { generateMockOrders } from './userOrders.mock';
import { MOCK_USER_ORDERS } from './mocks.config';

export const useUserOrders = () => {
	const [orders, setOrders] = useState<IOrder[]>([]);
	// starts true: the consumer fetches on mount, and a loading-first paint
	// keeps the skeleton from flashing an empty state (content below would jump)
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	const getOrders = async () => {
		setLoading(true);
		if (MOCK_USER_ORDERS) {
			// small artificial latency so the skeleton state is visible in dev
			await new Promise((resolve) => setTimeout(resolve, 800));
			setOrders(generateMockOrders());
			setLoading(false);
			return;
		}
		try {
			const response = await fetchData<IOrder[]>(
				`/api/orders`,
				{
					method: 'GET',
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				consoleDev('orders', ConsoleStatus.HTTP, response.status);
				setError(true);
			}
			if (response.data) {
				consoleDev('orders', ConsoleStatus.SUCC);
				setOrders(response.data);
			}
		} catch (err) {
			consoleDev('orders', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	return {
		orders,
		loading,
		error,
		getOrders,
	};
};
